export default {
  computed: {
    allVariantInfo() {
      if (!this.$apptimize || !this.$apptimize.root) {
        return [];
      }

      try {
        const variantInfo = this.$apptimize.root.getVariantInfo();
        if (Array.isArray(variantInfo)) {
          return variantInfo.map(variant => ({
            experimentName: variant.getExperimentName ? variant.getExperimentName() : 'unknown',
            variantName: variant.getVariantName ? variant.getVariantName() : 'unknown',
          }));
        }
        return [];
      } catch (error) {
        console.error('Error getting variant info:', error);
        return [];
      }
    },
  },
  methods: {
    getVariantInfoByExperiment(experimentName) {
      return this.allVariantInfo.find(v => v.experimentName === experimentName);
    },
  },
};
